import { render } from "./Datos.vue?vue&type=template&id=763381eb"
import script from "./Datos.vue?vue&type=script&lang=js"
export * from "./Datos.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__